import * as React from "react";
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Layout from "../Layout";

export default function PageNotFound() {
  return (
    <Layout>
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            "\n    \n    * {\n    margin:0;\n    padding:0;\n    color: #000;\n    font-family: 'Poppins', sans-serif;\n    }\n    body{\n    background-image: url('/images/generic-bacgound.jpg');\n    background-size: cover;\n    background-repeat: no-repeat;\n    }\n    .h1-main-header{\n    font-size: 75px;\n    color: #FF6300;\n    }\n    .h1-main-header img{\n    margin-bottom: -9px;\n    margin-left: 7px;\n    }\n    .p-1{\n    color: #5C0FD9;\n    font-weight: 600;\n    padding: 6px 0px;\n    font-size: 19px;\n    }\n    .p-2{\n    color: grey;\n    font-weight: 500;\n    padding-bottom: 5px;\n    padding-top: 34px;\n    }\n    .p-3{\n    color: #FF6300;\n    line-height: 24px;\n    font-weight: 500;\n    }\n    .container{\n    padding-left: 243px;\n    margin-top: 218px;\n    }\n    @media screen and (min-width: 1375px){\n    .h1-main-header{\n    font-size: 81px!important;\n    }\n    .p-1 {\n    font-weight: 600;\n    padding: 6px 0px;\n    font-size: 23px;\n    }\n    .p-2{\n    font-size: 22px;\n    \n    }\n    .p-3 {\n    line-height: 28px;\n    padding-top: 6px;\n    font-size: 20px;\n    }\n    }\n    @media screen and (min-width: 1366px){\n    .h1-main-header{\n    font-size: 65px;\n    }\n    }\n    @media screen and (max-width: 1024px){\n    .container {\n    padding-left: 53px;\n    margin-top: 53px;\n    }\n    .h1-main-header {\n    font-size: 49px;\n    }\n    .p-1 {\n    font-size: 15px;\n    }\n    .p-2 {\n    font-size: 19px;\n    }\n    .p-3{\n    font-size: 17px;\n    }\n    @media screen and (max-width: 425px){\n    .container {\n    padding-left: 22px;\n    margin-top: 16px;\n    }\n    .h1-main-header {\n    font-size: 22px;\n    }\n    .p-1 {\n    font-weight: 600;\n    padding: 3px 0px;\n    font-size: 7px;\n    }\n    .p-2 {\n    font-size: 9px;\n    padding-top: 0px;\n    }\n    .p-3 {\n    line-height: 16px;\n    font-weight: 500;\n    font-size: 9px;\n    }\n    .h1-main-header img {\n    margin-bottom: -5px;\n    margin-left: 4px;\n    width: 28px;\n    }\n    }\n    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300&display=swap');\n    "
        }}
      />
      {/* ------------ Heading -------------------- */}
      <div className="">
        <div className="container">
          <h1 className="h1-main-header">
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>It's not you, it's us.</div>
              <div>
                <img src="/images/heart.png" />
              </div>
            </div>
          </h1>
          <br />
          <p className="p-1">Sorry, the page you are looking for is temporarily unavailable.</p>
          <p className="p-1">We will be back with you shortly.</p>
          <br />
          <br />
          <p className="p-2">For any immediate assistance, please contact:</p>
          <p className="p-3">
            Email: info@akasaair.com <br />
            Call: +91 9606 11 21 31
          </p>
        </div>
      </div>
      {/* ----------------- Close Heading ------------------ */}
    </Layout>
  );
}
